import React, { useState } from 'react';

const PasswordConfirmModal = ({ isOpen, onClose, onConfirm, isProcessing = false, message }) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!password.trim()) {
            setError('Password is required');
            return;
        }

        setError('');
        await onConfirm(password);

        // Clear password after confirmation attempt
        setPassword('');
    };

    const handleClose = () => {
        setPassword('');
        setError('');
        onClose();
    };

    // Clear password when modal closes
    React.useEffect(() => {
        if (!isOpen) {
            setPassword('');
            setError('');
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2001
        }}>
            <div style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                padding: '24px',
                maxWidth: '450px',
                width: '90%'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    marginBottom: '16px'
                }}>
                    <span style={{ fontSize: '32px' }}>⚠️</span>
                    <h2 style={{
                        fontSize: '20px',
                        fontWeight: '600',
                        margin: 0,
                        color: '#DC2626'
                    }}>
                        Warning - Confirm Password
                    </h2>
                </div>

                <p style={{
                    fontSize: '14px',
                    color: '#374151',
                    marginBottom: '20px',
                    lineHeight: '1.5',
                    fontWeight: '500'
                }}>
                    {message || 'This action requires password confirmation. Please enter your password to continue.'}
                </p>

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            fontSize: '14px',
                            fontWeight: '500',
                            color: '#374151'
                        }}>
                            Password
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                setError('');
                            }}
                            placeholder="Enter your password"
                            autoFocus
                            autoComplete="off"
                            name="password-confirm-delete"
                            disabled={isProcessing}
                            style={{
                                width: '100%',
                                padding: '10px',
                                border: `1px solid ${error ? '#EF4444' : '#D1D5DB'}`,
                                borderRadius: '4px',
                                fontSize: '14px',
                                outline: 'none'
                            }}
                            onFocus={(e) => !error && (e.target.style.borderColor = '#3B82F6')}
                            onBlur={(e) => !error && (e.target.style.borderColor = '#D1D5DB')}
                        />
                        {error && (
                            <p style={{
                                color: '#EF4444',
                                fontSize: '12px',
                                marginTop: '4px'
                            }}>
                                {error}
                            </p>
                        )}
                    </div>

                    <div style={{
                        display: 'flex',
                        gap: '12px',
                        justifyContent: 'flex-end'
                    }}>
                        <button
                            type="button"
                            onClick={handleClose}
                            disabled={isProcessing}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: 'white',
                                border: '1px solid #D1D5DB',
                                borderRadius: '4px',
                                cursor: isProcessing ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                fontWeight: '500',
                                color: '#374151'
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isProcessing}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: isProcessing ? '#9CA3AF' : '#DC2626',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: isProcessing ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                fontWeight: '500'
                            }}
                        >
                            {isProcessing ? 'Verifying...' : 'Confirm Delete'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PasswordConfirmModal;
